import "./Project.css"
import bettingImage from '../images/ProPredicts.png'
import smartRentImage from '../images/SmartRentals.png'

const Project = () => 
{
    return(
        <section className="projects">
            <div className="project-card">
                    <div className="overlay">
                        <img 
                            src={smartRentImage} 
                            alt="Project Screenshot"
                            className="project-image"
                        />
                        <h3>Smart Rentals Saas application</h3>
                        <p>Releasing Summer of 2026</p>
                    </div>
            </div>
            <div className="project-card">
                    <div className="overlay">
                        <img 
                            src={bettingImage} 
                            alt="Project Screenshot"
                            className="project-image"
                        />
                        <h3>Sports prediction Saas application</h3>
                        <p>Still in development</p>
                    </div>
            </div>
        </section>
    );
}

export default Project;